module.exports = __webpack_public_path__ + "assets/img/location.71636931.svg";